import { createRoute } from '@tanstack/react-router'
import { EditProfileFormPage } from '@/features/profiles/pages/EditProfileFormPage'
import { Route as profilesRoute } from '../../profiles'

export const Route = createRoute({
  getParentRoute: () => profilesRoute,
  path: '/edit/$id',
  component: EditProfileFormPage,
})
